import React, { useEffect, useState, ChangeEvent ,useRef} from 'react';
import progressAnimation from '@/assets/animation/save_loader.json';
import { ReactComponent as UserIcon } from '@/assets/img/user-flat.svg';
import { Button } from '@/components/Elements';
import { Header } from '@/features/availability/components/Header';
import { PetHeader } from '@/features/availability/components/PetHeader';
import InputMask from 'react-input-mask';
import { useAuth } from '@/lib/auth';
import { useAddPet,useUploadPicture } from '../api/addPet';
import Lottie from 'lottie-react';
import { default as ReactSelect, components } from 'react-select';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import DatePicker,{ DayValue, DayRange, Day } from 'react-modern-calendar-datepicker';
import moment from 'moment';
import './css/PetProfile.scss'
import { SimpleHeader } from './SimpleHeader';
import Form from 'react-bootstrap/Form';
import { boolean } from 'zod';
// import { DashboardPetProfile } from './DashboardPetProfile';
import { useLocation } from "react-router-dom";

type Props = {
  fromMenu?:boolean;
  onSuccess?: () => void;
  onBackClick?: () => void;
}
export const PetDetail = ({ onSuccess, onBackClick,fromMenu }: Props) => {
  const location = useLocation()
  const { user, refetchUser } = useAuth();
  const addPetMutation = useAddPet();
  const uploadPicture = useUploadPicture();
  const fileInputRef = useRef(null);
  const [name, setName] = useState('');
  const [dob, setdob] = useState('');
  const [petsId, setId] = useState(NaN);
  const [uploadedImage, setUploadedImage] = useState<string>();
  const [showScreen, setShowScreen] = useState('Profile');
  const updateScreen = (value: string) => {
    setShowScreen(value);
  };

  useEffect(() => {
   
    if(user&&user.pets&&user.pets.length>0)
    {
      const {state} = location
      const indexOfPet = user.pets.findIndex((ele)=>ele.id===state)
      const p=user.pets[indexOfPet];
      setName(p.name);
      setdob(p.dateOfBirth)
      setUploadedImage(p.petsImageUrl)
      setId(p.id)
    }
  }, []);  



  return (
    <div className="full-height">
      <div className="top-cotent vacination-tab">
        <SimpleHeader
          onBackClick={() => {
            if (onBackClick) {
              onBackClick();
            }
          }}
          screenTitle={"Pet "+showScreen}
        />
        <div>
        </div>

        <div className="card-background">
              <PetHeader name={name} dob={dob} petsId ={petsId} uploadedImage1={uploadedImage} />
            
            {" "}
            <div className='row card-height'>
              
                          </div>
          </div>
        </div>

      
    </div>
  );
};